// import React, { useEffect, useState, useCallback, useMemo } from 'react';
// import {
// 	Box,
// 	Typography,
// 	Grid,
// 	CircularProgress,
// 	Accordion,
// 	AccordionSummary,
// 	AccordionDetails,
// 	Avatar,
// 	Dialog,
// 	DialogTitle,
// 	DialogContent,
// 	IconButton,
// 	Select,
// 	MenuItem,
// 	FormControl,
// 	InputLabel,
// 	Button,
// 	SelectChangeEvent,
// 	Tooltip,
// } from '@mui/material';
// import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
// import CloseIcon from '@mui/icons-material/Close';
// import { getAllCategories, getSingleCategorySubproducts } from '../../../../services/api/MenuAPI';

// interface Category {
// 	_id: string;
// 	name: string;
// 	description: string;
// 	categoryImage: string;
// }

// interface Subcategory {
// 	_id: string;
// 	subCategory: string;
// 	description: string;
// 	subCategoryImage: string;
// }

// const ROW_OPTIONS = [5, 10, 15, 20];

// export default function MenuContainer1() {
// 	const [categories, setCategories] = useState<Category[]>([]);
// 	const [expanded, setExpanded] = useState<string[]>([]);
// 	const [loadingSub, setLoadingSub] = useState<Record<string, boolean>>({});
// 	const [subcategoriesMap, setSubcategoriesMap] = useState<Record<string, Subcategory[]>>({});
// 	const [selectedSub, setSelectedSub] = useState<Subcategory | null>(null);
// 	const [openDialog, setOpenDialog] = useState<boolean>(false);

// 	const [rowsPerPage, setRowsPerPage] = useState<number>(5);
// 	const [visibleRows, setVisibleRows] = useState<number>(20);
// 	const [showAll, setShowAll] = useState<boolean>(false);

// 	useEffect(() => {
// 		const fetchAllCategories = async () => {
// 			try {
// 				const response = await getAllCategories();
// 				const cats: Category[] = response?.data?.categories || [];
// 				setCategories(cats);
// 			} catch (error) {
// 				console.error('Error fetching categories', error);
// 			}
// 		};
// 		fetchAllCategories();
// 	}, []);

// 	const handleAccordionChange = useCallback(
// 		(categoryName: string) => async (_: React.SyntheticEvent, isExpanded: boolean) => {
// 			setExpanded((prev) =>
// 				isExpanded ? [...prev, categoryName] : prev.filter((name) => name !== categoryName)
// 			);

// 			if (isExpanded && !subcategoriesMap[categoryName]) {
// 				setLoadingSub((prev) => ({ ...prev, [categoryName]: true }));
// 				try {
// 					const response = await getSingleCategorySubproducts(categoryName);
// 					const subs: Subcategory[] = response?.data?.subcategories || [];
// 					setSubcategoriesMap((prev) => ({ ...prev, [categoryName]: subs }));
// 				} catch (error) {
// 					console.error('Error fetching subcategories', error);
// 				} finally {
// 					setLoadingSub((prev) => ({ ...prev, [categoryName]: false }));
// 				}
// 			}
// 		},
// 		[subcategoriesMap]
// 	);

// 	const handleCardClick = (sub: Subcategory) => {
// 		setSelectedSub(sub);
// 		setOpenDialog(true);
// 	};

// 	const handleCloseDialog = () => {
// 		setOpenDialog(false);
// 		setSelectedSub(null);
// 	};

// 	const handleLoadMore = () => {
// 		setVisibleRows((prev) => prev + rowsPerPage);
// 	};

// 	const handleShowAll = () => {
// 		setShowAll(true);
// 	};

// 	const handleRowsPerPageChange = (event: SelectChangeEvent<number>) => {
// 		const value = event.target.value as number;
// 		setRowsPerPage(value);
// 		setVisibleRows(value);
// 		setShowAll(false);
// 	};

// 	const displayedCategories = useMemo(
// 		() => (showAll ? categories : categories.slice(0, visibleRows)),
// 		[categories, visibleRows, showAll]
// 	);

// 	const renderAccordion = (category: Category) => (
// 		<Box key={category._id} mb={2}>
// 			<Accordion
// 				expanded={expanded.includes(category.name)}
// 				onChange={handleAccordionChange(category.name)}
// 				sx={{ borderRadius: 2 }}
// 			>
// 				<AccordionSummary expandIcon={<ExpandMoreIcon />}>
// 					<Box display="flex" alignItems="center">
// 						<Avatar
// 							src={category.categoryImage}
// 							sx={{ width: 56, height: 56, mr: 2 }}
// 							variant="rounded"
// 						/>
// 						<Box>
// 							<Typography variant="subtitle1" fontWeight="bold">
// 								{category.name}
// 							</Typography>
// 							<Tooltip title={category.description || ''}>
// 								<Typography
// 									variant="body2"
// 									color="textSecondary"
// 									sx={{
// 										whiteSpace: 'nowrap',
// 										overflow: 'hidden',
// 										textOverflow: 'ellipsis',
// 										cursor: 'default', // Optional: shows pointer if it's interactive
// 										maxWidth: 500, // Optional: restricts width for ellipsis
// 									}}
// 								>
// 									{category.description}
// 								</Typography>
// 							</Tooltip>
// 						</Box>
// 					</Box>
// 				</AccordionSummary>

// 				<AccordionDetails>
// 					{loadingSub[category.name] && expanded.includes(category.name) ? (
// 						<Box display="flex" justifyContent="center" my={2}>
// 							<CircularProgress />
// 						</Box>
// 					) : subcategoriesMap[category.name]?.length > 0 ? (
// 						<Grid container spacing={2}>
// 							{subcategoriesMap[category.name].map((sub) => (
// 								<Grid size={{ xs: 6, sm: 4, md: 2 }} key={sub._id}>
// 									<Box
// 										onClick={() => handleCardClick(sub)}
// 										sx={{
// 											cursor: 'pointer',
// 											backgroundColor: '#fff',
// 											borderRadius: 2,
// 											boxShadow: 2,
// 											overflow: 'hidden',
// 											transition: 'transform 0.3s',
// 											'&:hover': {
// 												transform: 'scale(1.02)',
// 												boxShadow: 4,
// 											},
// 										}}
// 									>
// 										<img
// 											src={sub.subCategoryImage}
// 											alt={sub.subCategory}
// 											style={{
// 												width: '100%',
// 												height: 140,
// 												objectFit: 'cover',
// 											}}
// 										/>
// 										<Box p={1}>
// 											<Tooltip title={sub.subCategory} followCursor>
// 												<Typography
// 													variant="subtitle2"
// 													fontWeight="bold"
// 													sx={{
// 														overflow: 'hidden',
// 														textOverflow: 'ellipsis',
// 														whiteSpace: 'nowrap',
// 													}}
// 												>
// 													{sub.subCategory}
// 												</Typography>
// 											</Tooltip>
// 										</Box>
// 									</Box>
// 								</Grid>
// 							))}
// 						</Grid>
// 					) : (
// 						<Typography color="gray">Datas are updating...</Typography>
// 					)}
// 				</AccordionDetails>
// 			</Accordion>
// 		</Box>
// 	);

// 	return (
// 		<Box padding={2}>
// 			<Box textAlign="center" padding={3}>
// 				<Typography variant="h6" gutterBottom>
// 					Explore our thoughtfully crafted wedding menu selections designed to impress
// 					every guest. While each package offers a complete dining experience, we’re happy
// 					to tailor dishes to suit your unique tastes and traditions.
// 				</Typography>
// 			</Box>

// 			<Grid container spacing={2}>
// 				<Grid size={{ xs: 12, md: 6 }}>
// 					{/* {displayedCategories.slice(0, 10).map(renderAccordion)} */}
// 					{displayedCategories.filter((_, index) => index % 2 === 0).map(renderAccordion)}
// 				</Grid>
// 				<Grid size={{ xs: 12, md: 6 }}>
// 					{/* {displayedCategories.slice(10).map(renderAccordion)} */}
// 					{displayedCategories.filter((_, index) => index % 2 === 0).map(renderAccordion)}

// 					{/* Pagination Controls */}
// 					{categories.length > 5 && (
// 						<Box
// 							display="flex"
// 							justifyContent="space-between"
// 							alignItems="center"
// 							mt={4}
// 							sx={{ flexDirection: { xs: 'column', sm: 'row' } }}
// 						>
// 							<FormControl
// 								size="small"
// 								sx={{
// 									width: { xs: '100%', sm: 'auto' },
// 									marginBottom: { xs: '10px', sm: '0px' },
// 									minWidth: 120,
// 								}}
// 							>
// 								<InputLabel>Row Per Page</InputLabel>
// 								<Select
// 									value={rowsPerPage}
// 									label="Row Per Page"
// 									onChange={handleRowsPerPageChange}
// 								>
// 									{ROW_OPTIONS.map((option) => (
// 										<MenuItem key={option} value={option}>
// 											{option}
// 										</MenuItem>
// 									))}
// 								</Select>
// 							</FormControl>

// 							<Box display="flex" gap={2}>
// 								{!showAll && visibleRows < categories.length && (
// 									<Button
// 										variant="contained"
// 										color="error"
// 										onClick={handleLoadMore}
// 									>
// 										Load More
// 									</Button>
// 								)}
// 								{!showAll && (
// 									<Button
// 										variant="outlined"
// 										color="error"
// 										onClick={handleShowAll}
// 									>
// 										Show All
// 									</Button>
// 								)}
// 							</Box>
// 						</Box>
// 					)}
// 				</Grid>
// 			</Grid>

// 			{/* Dialog Popup */}
// 			<Dialog open={openDialog} onClose={handleCloseDialog} fullWidth maxWidth="sm">
// 				<DialogTitle>
// 					{selectedSub?.subCategory}
// 					<IconButton
// 						aria-label="close"
// 						onClick={handleCloseDialog}
// 						sx={{ position: 'absolute', right: 8, top: 8 }}
// 					>
// 						<CloseIcon />
// 					</IconButton>
// 				</DialogTitle>
// 				<DialogContent dividers>
// 					{selectedSub && (
// 						<Box display="flex" flexDirection="column" alignItems="center">
// 							<img
// 								src={selectedSub.subCategoryImage}
// 								alt={selectedSub.subCategory}
// 								style={{
// 									width: '100%',
// 									maxHeight: 250,
// 									objectFit: 'contain',
// 									marginBottom: 16,
// 								}}
// 							/>
// 							<Typography variant="h4">{selectedSub.subCategory}</Typography>
// 							<Typography variant="body2" color="textSecondary" mt={1}>
// 								{selectedSub.description}
// 							</Typography>
// 						</Box>
// 					)}
// 				</DialogContent>
// 			</Dialog>
// 		</Box>
// 	);
// }

import React, { useEffect, useState, useCallback, useMemo } from 'react';
import {
	Box,
	Typography,
	Grid,
	CircularProgress,
	Accordion,
	AccordionSummary,
	AccordionDetails,
	Avatar,
	Dialog,
	DialogTitle,
	DialogContent,
	IconButton,
	Select,
	MenuItem,
	FormControl,
	InputLabel,
	Button,
	SelectChangeEvent,
	Tooltip,
} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import CloseIcon from '@mui/icons-material/Close';
import { getAllCategories, getSingleCategorySubproducts } from '../../../../services/api/MenuAPI';

interface Category {
	_id: string;
	name: string;
	description: string;
	categoryImage: string;
}

interface Subcategory {
	_id: string;
	subCategory: string;
	description: string;
	subCategoryImage: string;
}

const ROW_OPTIONS = [10, 15, 20];

export default function MenuContainer1() {
	const [categories, setCategories] = useState<Category[]>([]);
	const [expanded, setExpanded] = useState<string[]>([]);
	const [loadingSub, setLoadingSub] = useState<Record<string, boolean>>({});
	const [subcategoriesMap, setSubcategoriesMap] = useState<Record<string, Subcategory[]>>({});
	const [selectedSub, setSelectedSub] = useState<Subcategory | null>(null);
	const [openDialog, setOpenDialog] = useState<boolean>(false);

	const [rowsPerPage, setRowsPerPage] = useState<number>(20);
	const [visibleRows, setVisibleRows] = useState<number>(20);
	const [showAll, setShowAll] = useState<boolean>(false);

	useEffect(() => {
		const fetchAllCategories = async () => {
			try {
				const response = await getAllCategories();
				const cats: Category[] = response?.data?.categories || [];
				setCategories(cats);
			} catch (error) {
				console.error('Error fetching categories', error);
			}
		};
		fetchAllCategories();
	}, []);

	const handleAccordionChange = useCallback(
		(categoryName: string) => async (_: React.SyntheticEvent, isExpanded: boolean) => {
			setExpanded((prev) =>
				isExpanded ? [...prev, categoryName] : prev.filter((name) => name !== categoryName)
			);

			if (isExpanded && !subcategoriesMap[categoryName]) {
				setLoadingSub((prev) => ({ ...prev, [categoryName]: true }));
				try {
					const response = await getSingleCategorySubproducts(categoryName);
					const subs: Subcategory[] = response?.data?.subcategories || [];
					setSubcategoriesMap((prev) => ({ ...prev, [categoryName]: subs }));
				} catch (error) {
					console.error('Error fetching subcategories', error);
				} finally {
					setLoadingSub((prev) => ({ ...prev, [categoryName]: false }));
				}
			}
		},
		[subcategoriesMap]
	);

	const handleCardClick = (sub: Subcategory) => {
		setSelectedSub(sub);
		setOpenDialog(true);
	};

	const handleCloseDialog = () => {
		setOpenDialog(false);
		setSelectedSub(null);
	};

	const handleLoadMore = () => {
		setVisibleRows((prev) => prev + rowsPerPage);
	};

	const handleShowAll = () => {
		setShowAll(true);
	};

	const handleRowsPerPageChange = (event: SelectChangeEvent<number>) => {
		const value = event.target.value as number;
		setRowsPerPage(value);
		setVisibleRows(value);
		setShowAll(false);
	};

	const displayedCategories = useMemo(
		() => (showAll ? categories : categories.slice(0, visibleRows)),
		[categories, visibleRows, showAll]
	);

	// ✅ Split evenly into two columns
	const half = Math.ceil(displayedCategories.length / 2);
	const leftColumn = displayedCategories.slice(0, half);
	const rightColumn = displayedCategories.slice(half);

	const renderAccordion = (category: Category) => (
		<Box key={category._id} mb={2}>
			<Accordion
				expanded={expanded.includes(category.name)}
				onChange={handleAccordionChange(category.name)}
				sx={{ borderRadius: 2 }}
			>
				<AccordionSummary expandIcon={<ExpandMoreIcon />}>
					<Box display="flex" alignItems="center">
						<Avatar
							src={category.categoryImage}
							sx={{ width: 56, height: 56, mr: 2 }}
							variant="rounded"
						/>
						<Box>
							<Typography variant="subtitle1" fontWeight="bold">
								{category.name}
							</Typography>
							<Tooltip title={category.description || ''}>
								<Typography
									variant="body2"
									color="textSecondary"
									sx={{
										whiteSpace: 'nowrap',
										overflow: 'hidden',
										textOverflow: 'ellipsis',
										cursor: 'default',
										maxWidth: { xs: 200, sm: 300, md: 500 },
									}}
								>
									{category.description}
								</Typography>
							</Tooltip>
						</Box>
					</Box>
				</AccordionSummary>

				<AccordionDetails>
					{loadingSub[category.name] && expanded.includes(category.name) ? (
						<Box display="flex" justifyContent="center" my={2}>
							<CircularProgress />
						</Box>
					) : subcategoriesMap[category.name]?.length > 0 ? (
						<Grid container spacing={2}>
							{subcategoriesMap[category.name].map((sub) => (
								<Grid size={{ xs: 6, sm: 4, md: 2 }} key={sub._id}>
									<Box
										onClick={() => handleCardClick(sub)}
										sx={{
											cursor: 'pointer',
											backgroundColor: '#fff',
											borderRadius: 2,
											boxShadow: 2,
											overflow: 'hidden',
											transition: 'transform 0.3s',
											'&:hover': {
												transform: 'scale(1.02)',
												boxShadow: 4,
											},
										}}
									>
										<img
											src={sub.subCategoryImage}
											alt={sub.subCategory}
											style={{
												width: '100%',
												height: 140,
												objectFit: 'cover',
											}}
										/>
										<Box p={1}>
											<Tooltip title={sub.subCategory} followCursor>
												<Typography
													variant="subtitle2"
													fontWeight="bold"
													sx={{
														overflow: 'hidden',
														textOverflow: 'ellipsis',
														whiteSpace: 'nowrap',
													}}
												>
													{sub.subCategory}
												</Typography>
											</Tooltip>
										</Box>
									</Box>
								</Grid>
							))}
						</Grid>
					) : (
						<Typography color="gray">Datas are updating...</Typography>
					)}
				</AccordionDetails>
			</Accordion>
		</Box>
	);

	return (
		<Box padding={2}>
			<Box textAlign="center" padding={3}>
				<Typography variant="h6" gutterBottom>
					Explore our thoughtfully crafted wedding menu selections designed to impress
					every guest. While each package offers a complete dining experience, we’re happy
					to tailor dishes to suit your unique tastes and traditions.
				</Typography>
			</Box>

			<Grid container spacing={2}>
				<Grid size={{ xs: 12, md: 6 }}>{leftColumn.map(renderAccordion)}</Grid>
				<Grid size={{ xs: 12, md: 6 }}>
					{rightColumn.map(renderAccordion)}

					{/* Pagination Controls */}
					{categories.length > 5 && (
						<Box
							display="flex"
							justifyContent="space-between"
							alignItems="center"
							mt={4}
							sx={{ flexDirection: { xs: 'column', sm: 'row' } }}
						>
							<FormControl
								size="small"
								sx={{
									width: { xs: '100%', sm: 'auto' },
									marginBottom: { xs: '10px', sm: '0px' },
									minWidth: 120,
								}}
							>
								<InputLabel>Row Per Page</InputLabel>
								<Select
									value={rowsPerPage}
									label="Row Per Page"
									onChange={handleRowsPerPageChange}
								>
									{ROW_OPTIONS.map((option) => (
										<MenuItem key={option} value={option}>
											{option}
										</MenuItem>
									))}
								</Select>
							</FormControl>

							<Box display="flex" gap={2}>
								{!showAll && visibleRows < categories.length && (
									<Button
										variant="contained"
										color="error"
										onClick={handleLoadMore}
									>
										Load More
									</Button>
								)}
								{!showAll && (
									<Button
										variant="outlined"
										color="error"
										onClick={handleShowAll}
									>
										Show All
									</Button>
								)}
							</Box>
						</Box>
					)}
				</Grid>
			</Grid>

			{/* Dialog Popup */}
			<Dialog open={openDialog} onClose={handleCloseDialog} fullWidth maxWidth="sm">
				<DialogTitle>
					{selectedSub?.subCategory}
					<IconButton
						aria-label="close"
						onClick={handleCloseDialog}
						sx={{ position: 'absolute', right: 8, top: 8 }}
					>
						<CloseIcon />
					</IconButton>
				</DialogTitle>
				<DialogContent dividers>
					{selectedSub && (
						<Box display="flex" flexDirection="column" alignItems="center">
							<img
								src={selectedSub.subCategoryImage}
								alt={selectedSub.subCategory}
								style={{
									width: '100%',
									maxHeight: 250,
									objectFit: 'contain',
									marginBottom: 16,
								}}
							/>
							<Typography variant="h4">{selectedSub.subCategory}</Typography>
							<Typography variant="body2" color="textSecondary" mt={1}>
								{selectedSub.description}
							</Typography>
						</Box>
					)}
				</DialogContent>
			</Dialog>
		</Box>
	);
}
